<template>
  <VisaForm country="bahrain" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
          <OccupationFields v-model="applicant.occupation" has-address />
        </template>
      </LazyApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>